import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';

const STORAGE_KEY = 'tribaldash_age_verified_v1';

function readShouldShowGate() {
  if (typeof window === 'undefined') return false;
  if (window.location.pathname.startsWith('/admin')) return false;
  if (window.location.pathname.startsWith('/driver')) return false;
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'true';
  } catch {
    return true;
  }
}

export default function AgeVerification() {
  const location = useLocation();
  const [open, setOpen] = useState(readShouldShowGate);

  useEffect(() => {
    if (location.pathname.startsWith('/admin') || location.pathname.startsWith('/driver')) {
      setOpen(false);
      return;
    }
    setOpen(readShouldShowGate());
  }, [location.pathname]);

  const handleConfirm = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      /* ignore */
    }
    setOpen(false);
  };

  const handleDecline = () => {
    window.location.href = 'https://www.google.com';
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (next) setOpen(true);
      }}
    >
      <DialogContent
        className="z-[100] max-w-md gap-6 [&>button]:hidden sm:rounded-xl"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="space-y-3 text-center sm:text-center">
          <DialogTitle className="text-xl sm:text-2xl">Age verification required</DialogTitle>
          <DialogDescription className="text-base leading-relaxed text-neutral-700">
            You must be at least <strong className="text-neutral-900">21 years of age</strong> or older
            to enter this site. Tribal Dash sells cannabis products intended only for adults in accordance
            with applicable law.
          </DialogDescription>
          <p className="text-sm text-neutral-600">
            By entering, you confirm that you are of legal age where you access this site and that you
            understand this website includes adult-oriented material.
          </p>
        </DialogHeader>
        <DialogFooter className="flex-col gap-3 sm:flex-col sm:space-x-0">
          <Button
            type="button"
            size="lg"
            className="w-full bg-green-600 text-white hover:bg-green-700"
            onClick={handleConfirm}
          >
            I am 21 or older — Enter site
          </Button>
          <Button type="button" size="lg" variant="outline" className="w-full" onClick={handleDecline}>
            I am under 21 — Exit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
